/* New Main Product JS - Compatible with iOS 10+ */

document.addEventListener('DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('[data-product-slider]');
  
  for (var s = 0; s < sliders.length; s++) {
    (function(mainSliderEl) {
      if (!mainSliderEl) return;
      
      var sectionId = mainSliderEl.getAttribute('data-product-slider');
      
      var mainSlider = new BlazeSlider(mainSliderEl, {
        all: {
          slidesToShow: 1,
          slideGap: '0px',
          loop: true,
          enableAutoplay: false,
          slidesToScroll: 1,
          transitionDuration: 300,
          enablePagination: true
        }
      });

      if (window.innerWidth >= 1024) {
        initThumbnailNavigation();
      }

      setTimeout(function() {
        var customThumbnails = mainSliderEl.querySelectorAll('.custom-thumbnail');
        var blazeDots = mainSliderEl.querySelectorAll('.blaze-pagination button:not(.custom-thumbnail)');
        var progressBar = mainSliderEl.querySelector('.progress-bar');
        var progressBarFill = progressBar ? progressBar.querySelector('.progress-bar__fill') : null;
        var totalSlides = customThumbnails.length;
        
        if (customThumbnails.length === 0 || blazeDots.length === 0) return;

        function updateProgressBar(activeIndex) {
          if (progressBarFill && totalSlides > 0) {
            var progress = ((activeIndex + 1) / totalSlides) * 100;
            progressBarFill.style.width = progress + '%';
          }
        }

        function updateThumbnailsState(activeIndex) {
          for (var i = 0; i < customThumbnails.length; i++) {
            if (i === activeIndex) {
              customThumbnails[i].classList.add('is-active');
            } else {
              customThumbnails[i].classList.remove('is-active');
            }
          }

          if (window.innerWidth >= 1024) {
            var thumbnailContainer = document.querySelector('[data-thumbnail-container]');
            var activeThumb = customThumbnails[activeIndex];
            
            if (thumbnailContainer && activeThumb) {
              var containerRect = thumbnailContainer.getBoundingClientRect();
              var thumbRect = activeThumb.getBoundingClientRect();
              
              if (thumbRect.top < containerRect.top || thumbRect.bottom > containerRect.bottom) {
                activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }
          }

          updateProgressBar(activeIndex);
        }

        updateProgressBar(0);

        for (var t = 0; t < customThumbnails.length; t++) {
          (function(thumbnail, index) {
            thumbnail.addEventListener('click', function(e) {
              e.preventDefault();
              
              updateThumbnailsState(index);
              
              if (blazeDots[index]) {
                blazeDots[index].click();
              }
            });
          })(customThumbnails[t], t);
        }

        var paginationContainer = mainSliderEl.querySelector('.blaze-pagination');
        
        if (paginationContainer) {
          var observer = new MutationObserver(function() {
            var activeDotIndex = -1;
            for (var d = 0; d < blazeDots.length; d++) {
              if (blazeDots[d].classList.contains('active') || 
                  blazeDots[d].getAttribute('aria-current') === 'true') {
                activeDotIndex = d;
                break;
              }
            }
            
            if (activeDotIndex !== -1) {
              updateThumbnailsState(activeDotIndex);
            }
          });

          for (var d = 0; d < blazeDots.length; d++) {
            observer.observe(blazeDots[d], {
              attributes: true,
              attributeFilter: ['class', 'aria-current']
            });
          }
        }

        var track = mainSliderEl.querySelector('.blaze-track');
        if (track) {
          var lastTransform = '';
          
          setInterval(function() {
            var currentTransform = track.style.transform;
            
            if (currentTransform !== lastTransform) {
              lastTransform = currentTransform;
              
              setTimeout(function() {
                var activeDotIndex = -1;
                for (var d = 0; d < blazeDots.length; d++) {
                  if (blazeDots[d].classList.contains('active') || 
                      blazeDots[d].getAttribute('aria-current') === 'true') {
                    activeDotIndex = d;
                    break;
                  }
                }
                
                if (activeDotIndex !== -1) {
                  updateThumbnailsState(activeDotIndex);
                }
              }, 50);
            }
          }, 100);
        }
      }, 200);
    })(sliders[s]);
  }

  initImageZoom();
});

function initThumbnailNavigation() {
  var thumbnailContainer = document.querySelector('[data-thumbnail-container]');
  var arrowUp = document.querySelector('.thumbnail-arrow-up');
  var arrowDown = document.querySelector('.thumbnail-arrow-down');
  
  if (!thumbnailContainer || !arrowUp || !arrowDown) return;

  var thumbnails = thumbnailContainer.querySelectorAll('.custom-thumbnail');
  if (thumbnails.length === 0) return;

  var getScrollAmount = function() {
    var thumbHeight = thumbnails[0].offsetHeight;
    var gap = parseFloat(getComputedStyle(thumbnailContainer).gap) || 12;
    return thumbHeight + gap;
  };

  var updateArrowsState = function() {
    var isAtTop = thumbnailContainer.scrollTop <= 0;
    var isAtBottom = thumbnailContainer.scrollTop + thumbnailContainer.clientHeight >= thumbnailContainer.scrollHeight - 1;
    
    arrowUp.disabled = isAtTop;
    arrowDown.disabled = isAtBottom;
  };

  arrowUp.addEventListener('click', function(e) {
    e.preventDefault();
    thumbnailContainer.scrollBy({
      top: -getScrollAmount(),
      behavior: 'smooth'
    });
  });

  arrowDown.addEventListener('click', function(e) {
    e.preventDefault();
    thumbnailContainer.scrollBy({
      top: getScrollAmount(),
      behavior: 'smooth'
    });
  });

  thumbnailContainer.addEventListener('scroll', updateArrowsState);
  
  updateArrowsState();
  
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 1024) {
      updateArrowsState();
    }
  });
}

function initImageZoom() {
  if (window.innerWidth < 1024) return;

  var allZoomButtons = document.querySelectorAll('.zoom-icon-trigger');
  if (allZoomButtons.length === 0) return;

  var isZoomActive = false;
  var currentContainer = null;
  var currentImage = null;
  var currentLens = null;
  var currentZoomButton = null;

  for (var b = 0; b < allZoomButtons.length; b++) {
    (function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (currentZoomButton === button) {
          isZoomActive = !isZoomActive;
        } else {
          if (currentZoomButton) {
            currentZoomButton.classList.remove('active');
            deactivateZoom();
          }
          currentZoomButton = button;
          isZoomActive = true;
        }
        
        if (isZoomActive) {
          button.classList.add('active');
          activateZoom();
        } else {
          button.classList.remove('active');
          deactivateZoom();
          currentZoomButton = null;
        }
      });
    })(allZoomButtons[b]);
  }

  function activateZoom() {
    var track = document.querySelector('.blaze-track');
    if (!track) return;

    var slides = track.querySelectorAll('[data-zoom-container]');
    
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var rect = slide.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      
      if (rect.left >= trackRect.left - 10 && rect.left <= trackRect.left + 10) {
        currentContainer = slide;
        currentImage = slide.querySelector('img[data-zoom-image]');
        currentLens = slide.querySelector('.zoom-lens');
        
        if (currentContainer && currentImage && currentLens) {
          currentContainer.classList.add('zoom-active');
          setupZoomListeners();
        }
        break;
      }
    }
  }

  function deactivateZoom() {
    if (currentContainer) {
      currentContainer.classList.remove('zoom-active');
      if (currentLens) {
        currentLens.style.display = 'none';
      }
      removeZoomListeners();
    }
    currentContainer = null;
    currentImage = null;
    currentLens = null;
  }

  function setupZoomListeners() {
    if (!currentImage) return;
    
    currentImage.addEventListener('mousemove', handleZoomMove);
    currentImage.addEventListener('mouseleave', handleZoomLeave);
  }

  function removeZoomListeners() {
    if (!currentImage) return;
    
    currentImage.removeEventListener('mousemove', handleZoomMove);
    currentImage.removeEventListener('mouseleave', handleZoomLeave);
  }

  function handleZoomMove(e) {
    if (!isZoomActive || !currentLens || !currentImage) return;

    var rect = currentImage.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      currentLens.style.display = 'none';
      return;
    }

    currentLens.style.display = 'block';

    var lensWidth = 150;
    var lensHeight = 150;

    var lensX = x - lensWidth / 2;
    var lensY = y - lensHeight / 2;

    lensX = Math.max(0, Math.min(lensX, rect.width - lensWidth));
    lensY = Math.max(0, Math.min(lensY, rect.height - lensHeight));

    currentLens.style.left = lensX + 'px';
    currentLens.style.top = lensY + 'px';

    var zoomLevel = 1.5;
    var bgX = -(x * zoomLevel - lensWidth / 2);
    var bgY = -(y * zoomLevel - lensHeight / 2);

    var zoomImageUrl = currentImage.getAttribute('data-zoom-image') || currentImage.src;

    currentLens.style.backgroundImage = 'url(\'' + zoomImageUrl + '\')';
    currentLens.style.backgroundSize = (rect.width * zoomLevel) + 'px ' + (rect.height * zoomLevel) + 'px';
    currentLens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
  }

  function handleZoomLeave() {
    if (!isZoomActive) return;
    
    isZoomActive = false;
    if (currentZoomButton) {
      currentZoomButton.classList.remove('active');
    }
    deactivateZoom();
    currentZoomButton = null;
  }

  var track = document.querySelector('.blaze-track');
  if (track) {
    var observer = new MutationObserver(function() {
      updateVisibleZoomIcon();
      
      if (isZoomActive) {
        if (currentZoomButton) {
          currentZoomButton.classList.remove('active');
        }
        deactivateZoom();
        
        setTimeout(function() {
          var newActiveButton = getActiveSlideZoomButton();
          if (newActiveButton && isZoomActive) {
            currentZoomButton = newActiveButton;
            currentZoomButton.classList.add('active');
            activateZoom();
          }
        }, 100);
      }
    });

    observer.observe(track, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function updateVisibleZoomIcon() {
    var track = document.querySelector('.blaze-track');
    if (!track) return;

    var slides = track.querySelectorAll('[data-zoom-container]');
    var trackRect = track.getBoundingClientRect();

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var rect = slide.getBoundingClientRect();
      var button = slide.querySelector('.zoom-icon-trigger');
      
      if (button) {
        if (rect.left >= trackRect.left - 10 && rect.left <= trackRect.left + 10) {
          button.classList.remove('zoom-icon-hidden');
        } else {
          button.classList.add('zoom-icon-hidden');
        }
      }
    }
  }

  function getActiveSlideZoomButton() {
    var track = document.querySelector('.blaze-track');
    if (!track) return null;

    var slides = track.querySelectorAll('[data-zoom-container]');
    var trackRect = track.getBoundingClientRect();

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var rect = slide.getBoundingClientRect();
      if (rect.left >= trackRect.left - 10 && rect.left <= trackRect.left + 10) {
        return slide.querySelector('.zoom-icon-trigger');
      }
    }
    return null;
  }

  updateVisibleZoomIcon();
}
